import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import kavidaLogo from "../../../assets/images/kavida_logo.svg";

const TEXT_PRIMARY = "#171717";
const TEXT_SECONDARY = "#747474";
const BG = "#F7F7F7";
const BORDER = "#E8E8E8";

function ErrorFallback({ error }) {
  const errorMessage =
    error?.stack ||
    error?.message ||
    (error != null ? (() => { try { return JSON.stringify(error, null, 2); } catch (_) { return String(error); } })() : "Unknown error");
  const reportedAt = new Date().toISOString();

  return (
    <Box
      role="alert"
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: BG,
        padding: 2,
        fontFamily: "Figtree, sans-serif",
      }}
    >
      <Paper
        elevation={1}
        sx={{
          width: "100%",
          maxWidth: 520,
          padding: 4,
          borderRadius: 2,
          backgroundColor: "#FFFFFF",
          border: `1px solid ${BORDER}`,
          textAlign: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 3 }}>
          <img src={kavidaLogo} alt="Kavida" style={{ height: 32, width: "auto" }} />
        </Box>

        <Typography
          variant="h5"
          component="h1"
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            color: TEXT_PRIMARY,
            marginBottom: 1.5,
          }}
        >
          Something went wrong
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "14px",
            color: TEXT_SECONDARY,
            lineHeight: 1.5,
            marginBottom: 3,
          }}
        >
          We&apos;ve hit an unexpected issue, and we&apos;re sorry for the
          disruption.
          <br />
          <br />
          Please share the error details below with your Kavida team and
          we&apos;ll look into it.
        </Typography>

        <Box sx={{ textAlign: "left" }}>
          <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 600,
              color: TEXT_SECONDARY,
              marginBottom: 0.75,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            Error details
          </Typography>
          <Box
            component="pre"
            sx={{
              margin: 0,
              padding: 1.5,
              backgroundColor: BG,
              border: `1px solid ${BORDER}`,
              borderRadius: 1,
              fontSize: "12px",
              color: TEXT_PRIMARY,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              maxHeight: 140,
              overflow: "auto",
              fontFamily: "monospace",
            }}
          >
            {errorMessage}
          </Box>
          <Typography
            sx={{
              fontSize: "11px",
              color: TEXT_SECONDARY,
              marginTop: 0.75,
              fontFamily: "monospace",
            }}
          >
            Reported at: {reportedAt}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}

export default ErrorFallback;
